var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("🎉Post Good News of the week🎉")]),_c('FormItem',{on:{"input-item":function($event){return _vm.inputParentsItem($event)}}}),_c('List',{attrs:{"postList":_vm.postList},on:{"delete-item":function($event){return _vm.deletParentItem($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }